















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { Actions } from '@/util/vuex-types'
import Event from '@/models/event'
import moment from 'moment'
import axios from '@/server-axios'
import { Datetime } from 'vue-datetime'
import Brewery from '@/models/brewery'
import 'vue-datetime/dist/vue-datetime.css'

@Component({
    components: {
        datetime: Datetime,
    },
})
export default class CreateEvent extends Vue {
    eventLocation: string = ''
    submitting: boolean = false
    successfullyCreated = false
    date: string = moment().toISOString(true)
    error = false
    selectedBrewery: any = ''
    @Action [Actions.FETCH_EVENTS]: any
    @State breweries?: Brewery[]
    @Action [Actions.FETCH_BREWERIES]: any
    errorText = ''

    async mounted(){
        if (this.breweries === null || (this.breweries !== null && this.breweries.length === 0)) {
            this.fetchBreweries()
        }
    }

    async createBrewery() {
        try {
            const missingFields = []
            if (this.selectedBrewery === '' || this.selectedBrewery === null){
                missingFields.push('Brewery')
            }

            if (this.date === '' || this.date === null){
                missingFields.push('Event date')
            }

            if (this.eventLocation === '' || this.eventLocation === null){
                missingFields.push('Event location')
            }

            if(missingFields.length > 0){
                this.error = true
                this.errorText = 'The following fields are required: ' + missingFields.join(', ')
                return
            }


            this.successfullyCreated = false
            this.submitting = true
            this.error = false
            const request = {
               location: this.eventLocation,
               at: moment(this.date).format('DD-MM-YYYY hh:mm:ss A'),
            }
            const { status } = await axios.post('events/' + this.selectedBrewery, request, {
                headers: {
                    Authorization: 'Bearer ' + await this.$auth.getAccessToken(),
                },
            })

            if (status === 201) {
                this.successfullyCreated = true
                this.submitting = false
                this.fetchEvents()
            } else if (status >= 400) {
                this.error = true
                this.errorText = 'There was a problem'
                this.submitting = false
            }
        } catch (e) {
            console.warn(e)
        }
    }
}
